/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Editor_TextInputs */

const fr_legal_editor_text = /** @type {(inputs: Legal_Editor_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le présent site est édité à des fins non professionnelles par un particulier, agissant dans le cadre d'une activité de loisir.`)
};

const en_legal_editor_text = /** @type {(inputs: Legal_Editor_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This site is published for non-professional purposes by an individual as part of a leisure activity.`)
};

/**
* | output |
* | --- |
* | "This site is published for non-professional purposes by an individual as part of a leisure activity." |
*
* @param {Legal_Editor_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_editor_text = /** @type {((inputs?: Legal_Editor_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Editor_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_editor_text(inputs)
	return en_legal_editor_text(inputs)
});